import { render, staticRenderFns } from "./CurrencyRounded.vue?vue&type=template&id=776a9127&"
import script from "./CurrencyRounded.vue?vue&type=script&lang=ts&"
export * from "./CurrencyRounded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports